/* eslint-disable @typescript-eslint/no-unused-vars */
import { toUrlParams } from '../base/url'
import { jump2TemplateMethod } from './base'
import getDefaultDate from '../date'
import { reportInfo } from '../owl'
import { WX_PATH_PREFIX } from './mp-const'

interface I_DATE_PARAM {
  dateBegin?: string
  dateEnd?: string
  withDate?: boolean
}

interface I_PARAM extends I_DATE_PARAM {
  productId: string | number // 房源ID
  phxPoiId?: string | number // 民宿POI ID
  poiId?: string | number // 美团POI ID
  dpPoiId?: string | number // 点评POI ID
  coverImage?: string
  mrn_component?: string
  [x: string]: string | number | boolean | undefined
}

function getDateRange(params: I_DATE_PARAM) {
  const { withDate = true, dateBegin: startDate, dateEnd: endDate } = params
  // 设置默认日期
  let dateRange = {
    startDate,
    endDate,
  }
  if (withDate && !startDate && !endDate) {
    // 客户端参数名不统一要注意
    const { dateBegin: startDate, dateEnd: endDate } = getDefaultDate()
    dateRange = {
      startDate,
      endDate,
    }
  }
  return dateRange
}

export function getIPath(params: I_PARAM) {
  const {
    withDate,
    productId, // 房源ID
    phxPoiId, // 民宿POI ID
    poiId, // 美团POI ID
    dpPoiId, // 点评POI ID
    coverImage,
    dateBegin: startDate,
    dateEnd: endDate,
    mrn_component,
    ...extras
  } = params
  const dateRange = getDateRange(params)
  const queryString = toUrlParams({ ...extras, ...dateRange })
  let iPath = ''
  if (phxPoiId && !productId) {
    iPath = `/poi/${phxPoiId}${queryString ? `?${queryString}` : ''}`
    reportInfo({
      name: 'phxPoiId',
      msg: iPath,
      global: true,
    })
  } else if (productId) {
    iPath = `/housing/${productId}${queryString ? `?${queryString}` : ''}`
  }
  return iPath
}

/**
 * [$jump2housing 跳转到房源详情]
 * @param  {Object} params          [房源数据]
 */
export default function jump2housing(params: I_PARAM): void {
  const {
    productId, // 房源ID
    phxPoiId, // 民宿POI ID
    poiId, // 美团POI ID
    dpPoiId, // 点评POI ID
    coverImage,
    dateBegin: startDate,
    dateEnd: endDate,
    mrn_component,
    withDate,
    ...extras
  } = params
  const dateRange = getDateRange(params)
  const mpQueryString = toUrlParams({
    phxPoiId, // 民宿POI ID
    productId, // 房源ID
    mtPoiId: poiId, // 美团POI ID
    dpPoiId, // 点评POI ID
    ...dateRange,
    ...extras,
  })
  jump2TemplateMethod({
    iPath: getIPath(params),
    mpPathMap: {
      dianping_wxapp: `${WX_PATH_PREFIX.dianping}/product/product?${mpQueryString}`,
      group_wxapp: `${WX_PATH_PREFIX.meituan}/product/simple?${mpQueryString}`,
      hotel_wxapp: `${WX_PATH_PREFIX.hotel}/product/product?${mpQueryString}`,
      phoenix_wxapp: `${WX_PATH_PREFIX.phx}/product/product?${mpQueryString}`,
    },
    // RN 房源详情页 https://km.sankuai.com/page/125921503
    rnPathConfig: {
      versions: { phx: '3.5.0', meituan: '9.13.400', dianping: '10.13.0' },
      mrn_entry: 'product',
      mrn_component: mrn_component || 'zhenguo-product',
      mrn_translucent: true,
      params: {
        phxPoiId, // 榛果poiId
        productId, // 榛果房源id
        poiId, // 美团poiId
        dpPoiId, // 点评poiId
        phxImageUrl: coverImage,
        ...dateRange,
        ...extras,
      },
    },
  })
}
